import { z } from "zod"

// Campos de exibição vêm como `nullish` de propósito. O leilão nem sempre traz endereço, e o
// serviço devolve null nesse caso: `optional` aceitaria a ausência mas rejeita o null, e a página
// inteira cairia em "tivemos um problema por aqui" por causa de uma UF vazia.

const Bucket = z.object({ bucket: z.string(), people: z.number() })

export const VisaoSchema = z.object({
    employer: z.object({
        // O CNPJ completo para o qual o token foi assinado. Opcional enquanto houver serviço
        // devolvendo só a raiz: sem ele a página cairia inteira por um campo de cabeçalho.
        cnpj: z.string().nullish(),
        cnpj_root: z.string(),
        name: z.string().nullish(),
        city: z.string().nullish(),
        state: z.string().nullish(),
    }),
    window: z.object({
        from: z.coerce.date().nullish(),
        to: z.coerce.date().nullish(),
    }),
    totals: z.object({
        people: z.number(),
        requests: z.number(),
        requested_amount: z.number(),
        last_request_amount: z.number(),
        average_margin: z.number(),
        without_margin: z.number(),
    }),
    funnel: z.object({
        requests: z.number(),
        reached_auction: z.number(),
        best_offer: z.number(),
        opened: z.number(),
        signed: z.number(),
        approved_amount: z.number(),
        average_rate: z.number().nullish(),
        average_installments: z.number().nullish(),
        people_with_offer: z.number(),
    }),
    lost: z.array(z.object({ rank: z.number(), requests: z.number() })),
    drops: z.array(z.object({ reason: z.string(), requests: z.number() })),
    by_month: z.array(z.object({ month: z.string(), requests: z.number(), people: z.number() })),
    repeat: z.array(z.object({ requests: z.number(), people: z.number() })),
    distributions: z.object({
        margin: z.array(Bucket),
        age: z.array(Bucket),
        tenure: z.array(Bucket),
        amount: z.array(Bucket),
        installments: z.array(Bucket),
    }),
})
export type Visao = z.infer<typeof VisaoSchema>
